// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__3Ye0E","hamburger":"Sidebar_hamburger__2x-n0","linksContainer":"Sidebar_linksContainer__DSgzS","sidebarOpen":"Sidebar_sidebarOpen__2tfS8"};